import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { VscNotebookTemplate } from "react-icons/vsc";
import { FaRegUserCircle } from "react-icons/fa";
import axios from "axios";
import { API_URL } from "../config/global_constants";
import { FaWhatsapp } from "react-icons/fa";
import { MdContactPage } from "react-icons/md";
import { AiFillMessage } from "react-icons/ai";
import { MdMarkEmailRead } from "react-icons/md";
import { MdMiscellaneousServices } from "react-icons/md";
import { LMS_SECTIONS, canManage, canSee } from "../components/Lms/lmsAccess";

// Roles are cached per token so the menu renders instantly on reload / page change
// instead of staying empty until authMe responds.
const ROLES_CACHE_KEY = "auth_roles";

const getCachedRoles = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(ROLES_CACHE_KEY) || "null");
    return cached && cached.token === localStorage.getItem("token") ? cached.roles : null;
  } catch {
    return null;
  }
};

const LeftbarAdmin = ({ handleSidebarClose, customClass }) => {
  const location = useLocation();
  const [authUser, setauthUser] = useState(getCachedRoles);

  const isEarthwoodRoute = location.pathname.startsWith("/users-list") || location.pathname.startsWith("/persional-survey") || location.pathname.startsWith("/consumer-survey") || location.pathname.startsWith("/movies-list") || location.pathname.startsWith("/movies-review");
  const isEarningRoute = location.pathname.startsWith("/user-earning") || location.pathname.startsWith("/user-transaction");
  const userListRoutes = location.pathname.startsWith("/business") || location.pathname.startsWith("/creator") || location.pathname.startsWith("/others")
  const isContractRoute = location.pathname.startsWith("/create-contract") || location.pathname.startsWith("/request-contract") || location.pathname.startsWith("/upload-contract") || location.pathname.startsWith("/public-contract")
  const bluckEmailRoutes = location.pathname.startsWith("/create-template") || location.pathname.startsWith("/view-template") || location.pathname.startsWith("/email-user") || location.pathname.startsWith("/user-details") || location.pathname.startsWith("/assign-template") || location.pathname.startsWith("/all-contacts") || location.pathname.startsWith("/shoot-email")
  const isPlucLabRoutes = location.pathname.startsWith("/pluc-user") || location.pathname.startsWith('/pluc-lab-stroy')
  const isAssignRole = location.pathname.startsWith("/assign-role") || location.pathname.startsWith("/getuserwithrole-details")
  // const isAssignRole = location.pathname.startsWith("/assign-role")
  const isWhatsapp = location.pathname.startsWith("/whatsapp") ||
    location.pathname.startsWith("/message-template") ||
    location.pathname.startsWith("/view-template-message") ||
    location.pathname.startsWith("/all-contact") ||
    location.pathname.startsWith("/whatsapp-contact-list") ||
    location.pathname.startsWith("/send-whatsapp-message")


  let initialMenu = null;
  if (isContractRoute) {
    initialMenu = "contract";
  } else if (isEarthwoodRoute) {
    initialMenu = "earthwood";
  } else if (isEarningRoute) {
    initialMenu = "earning";
  } else if (userListRoutes) {
    initialMenu = "user-list";
  }
  else if (bluckEmailRoutes) {
    initialMenu = "bluckemail";
  }
  else if (isPlucLabRoutes) {
    initialMenu = "pluc-lab";
  }
  else if (isAssignRole) {
    initialMenu = "assign-role";
  }
  else if (isWhatsapp) {
    initialMenu = "whatsapp";
  }

  const [openMenu, setOpenMenu] = useState(initialMenu);

  const toggleMenu = (menuName) => {
    setOpenMenu((prev) => (prev === menuName ? null : menuName));
  };

  useEffect(() => {
    const Authme = async () => {
      try {
        const token = localStorage.getItem("token");

        if (!token) {
          console.log("No token found");
          setauthUser(null);
          return;
        }

        const result = await axios.get(`${API_URL}authMe`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        // console.log("Full response:", result?.data?.data);
        const userRoles = result?.data?.data?.roles || [];
        setauthUser(userRoles);
        localStorage.setItem(ROLES_CACHE_KEY, JSON.stringify({ token, roles: userRoles }));
      } catch (err) {
        console.error("Auth error:", err.response?.data || err.message);
        // Only drop the menu when the token is rejected, not on a network hiccup
        if (err.response?.status === 401) {
          localStorage.removeItem(ROLES_CACHE_KEY);
          setauthUser(null);
        }
      }
    };


    Authme();
  }, []);

  const adminRoleId = 1;
  const earthwoodAdminRoleId = 13;

  const hasAdminAccess = authUser?.some(role => role.id === adminRoleId);
  const hasEarthwoodAdminAccess = authUser?.some(role => role.id === earthwoodAdminRoleId);


  // console.log(authUser, "hasAdminAccess.....")

  if (location.pathname.startsWith("/lms")) {
    // a sub admin sees only the sections their role has
    const [lmsDashboard, ...sections] = LMS_SECTIONS;
    const lmsLinks = sections.filter((section) => canSee(section));

    return (
      <aside className={`sidenav navbar navbar-vertical navbar-expand-xs fixed-left no-scrollbar lms-sidenav ${customClass || ""}`} >
        <div className="sidenav-header">
          <div className="navbar-brand m-0">
            <img src="/img/logo.png" className="navbar-brand-img" alt="Logo" />
          </div>
        </div>
        <div className="collapse navbar-collapse w-auto">
          <ul className="navbar-nav">
            {canSee(lmsDashboard) && (
              <li className="nav-item" onClick={handleSidebarClose}>
                <NavLink className="nav-link" to="/lms" end>
                  <span className="nav-link-text ms-1">Dashboard</span>
                </NavLink>
              </li>
            )}
            {/* <li className="nav-item" >
              <NavLink className="nav-link" >
                <span className="nav-link-text ms-1">All Users</span>
              </NavLink>
            </li>
            <li className="nav-item" >
              <NavLink className="nav-link" >
                <span className="nav-link-text ms-1">Bulk Email</span>
              </NavLink>
            </li> */}
            <li className="lms-nav-section">TRAINING</li>
            {lmsLinks.map((link) => (
              <li className="nav-item" onClick={handleSidebarClose} key={link.to}>
                <NavLink className="nav-link" to={link.to}>
                  <span className="nav-link-text ms-1">{link.label}</span>
                </NavLink>
              </li>
            ))}
            {canManage() && (
              <>
                <li className="lms-nav-section">SETTINGS</li>
                <li className="nav-item" onClick={handleSidebarClose}>
                  <NavLink className="nav-link" to="/lms/sub-admins">
                    <span className="nav-link-text ms-1">Sub admins</span>
                  </NavLink>
                </li>
              </>
            )}
          </ul>
        </div>
      </aside>
    );
  }

  return (
    <>
      <aside className={`sidenav navbar navbar-vertical navbar-expand-xs fixed-left no-scrollbar ${customClass}`} >
        <div className="sidenav-header">
          <div className="navbar-brand m-0">
            <img
              src="/img/logo.png"
              className="navbar-brand-img h-100 w-13"
              alt="Logo"
              style={{ marginRight: "8px" }}
            />
          </div>
          <div>

          </div>

        </div>
        <div className="collapse navbar-collapse  w-auto">
          <ul className="navbar-nav">
            {hasAdminAccess && (
              <>
                <li className="nav-item" onClick={handleSidebarClose}>
                  <NavLink
                    className="nav-link  "
                    activeClassName=" active"
                    to={"/"}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <img
                        src="/image/dashbord.png"
                        alt="Dashboard"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <span className="nav-link-text ms-1">Dashboard</span>
                    </div>
                  </NavLink>
                </li>

                <li className="nav-item">
                  <div
                    className="nav-link d-flex align-items-center justify-content-between"
                    onClick={() => toggleMenu("contract")}
                    style={{ cursor: "pointer" }}
                  >
                    {/* Left side: icon + text */}
                    <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                      <img
                        src="/image/contract1.png"
                        alt="Contract"
                        style={{ width: "25px", height: "25px" }}
                      />
                      <span className="nav-link-text ms-1">Contract</span>
                    </div>
                    <i
                      className={`fas fa-chevron-${openMenu === "contract" ? "up" : "down"}`}
                      style={{ padding: "8px" }}
                    />
                  </div>
                  {openMenu === "contract" && (

                    <ul className="navbar-nav " style={{ paddingLeft: "10px" }}>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: "52px" }}>
                        <NavLink className="nav-link mt-1" to="/create-contract" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/createContract.png"
                              alt="Create Contract"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Create Contract</span>
                          </div>
                        </NavLink>
                      </li>

                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: "52px" }}>
                        <NavLink className="nav-link mt-1" to="/upload-contract" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/uplod.png"
                              alt="Upload Contract"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Upload Contract</span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: "52px" }}>
                        <NavLink className="nav-link mt-1" to="/request-contract" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/Icon.png"
                              alt="View Contract"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Internal Contract</span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: "52px" }}>
                        <NavLink className="nav-link mt-1" to="/public-contract" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/publicContract.png"
                              alt="public Contract"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Public Contract</span>
                          </div>
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
              </>
            )
            }



            {(hasEarthwoodAdminAccess) && (
              <>
                <li className="nav-item">
                  <div
                    className="nav-link d-flex align-items-center justify-content-between"
                    onClick={() => toggleMenu("earthwood")}
                    style={{ cursor: "pointer" }}
                  >

                    <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                      <img
                        src="/image/4.png"
                        alt="Earthwood"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <span className="nav-link-text ms-1">Earthwood</span>
                    </div>
                    <i
                      className={`fas fa-chevron-${openMenu === "earthwood" ? "up" : "down"}`}
                      style={{ padding: "8px" }}
                    />
                  </div>
                  {openMenu === "earthwood" && (
                    <ul className="navbar-nav " style={{ paddingLeft: "10px" }}>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: "52px" }}>
                        <NavLink className="nav-link mt-1" to="/users-list" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/5.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">User List</span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: "52px" }}>
                        <NavLink className="nav-link mt-1" to="/persional-survey" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/6.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Personal Details Survey</span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: "52px" }}>
                        <NavLink className="nav-link mt-1" to="/consumer-survey" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                            <img
                              src="/image/7.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Consumer Details Survey</span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: "52px" }}>
                        <NavLink className="nav-link mt-1" to="/movies-list" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/8.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Movies List</span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: "52px" }}>
                        <NavLink className="nav-link mt-1" to="/movies-review" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/9.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Movies Review List</span>
                          </div>
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
              </>
            )
            }

            {hasAdminAccess && (
              <>
                <li className="nav-item">
                  <div className="nav-link cursor-pointer d-flex align-items-center justify-content-between" onClick={() => toggleMenu("earning")} style={{ cursor: "pointer" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <img
                        src="/image/10.png"
                        alt="User Earning"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <span className="nav-link-text ms-1">User Earning</span>
                    </div>
                    <i className={`fas fa-chevron-${openMenu === "earning" ? "up" : "down"} ms-auto`} style={{ padding: "10px" }} />
                  </div>

                  {/* Submenu */}
                  {openMenu === "earning" && (
                    <ul className="navbar-nav " style={{ paddingLeft: "20px" }}>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/user-earning" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/10.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">User Earning List</span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/user-transaction" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/10.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">User Transaction List</span>
                          </div>
                        </NavLink>
                      </li>

                    </ul>
                  )}
                </li>
                <li className="nav-item">
                  <div className="nav-link cursor-pointer d-flex align-items-center justify-content-between" onClick={() => toggleMenu("user-list")} style={{ cursor: "pointer" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <img
                        src="/image/13.png"
                        alt="User Earning"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <span className="nav-link-text ms-1">All Users</span>
                    </div>
                    <i className={`fas fa-chevron-${openMenu === "user-list" ? "up" : "down"} ms-auto`} style={{ padding: "10px" }} />
                  </div>

                  {/* Submenu */}
                  {openMenu === "user-list" && (
                    <ul className="navbar-nav " style={{ paddingLeft: "20px" }}>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/creator" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/14.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Creator
                            </span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/business" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/15.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Business</span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/others" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/16.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Others Details</span>
                          </div>
                        </NavLink>
                      </li>

                    </ul>
                  )}
                </li>


                <li className="nav-item">
                  <div className="nav-link cursor-pointer d-flex align-items-center justify-content-between" onClick={() => toggleMenu("bluckemail")} style={{ cursor: "pointer" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <img
                        src="/image/13.png"
                        alt="User Earning"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <span className="nav-link-text ms-1">Bulk Email</span>
                    </div>
                    <i className={`fas fa-chevron-${openMenu === "bluckemail" ? "up" : "down"} ms-auto`} style={{ padding: "10px" }} />
                  </div>


                  {openMenu === "bluckemail" && (
                    <ul className="navbar-nav" style={{ paddingLeft: "20px" }}>
                      {/* <li className="nav-item" style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/create-template" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img src="/image/14.png" alt="Create Template" style={{ width: "20px", height: "20px" }} />
                            <span className="nav-link-text ms-1">Create Template</span>
                          </div>
                        </NavLink>
                      </li> */}

                      <li className="nav-item" style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/view-template" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <VscNotebookTemplate size={20} />
                            <span className="nav-link-text ms-1">View Template</span>
                          </div>
                        </NavLink>
                      </li>

                      <li className="nav-item" style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/email-user-list" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <MdMarkEmailRead size={20} />
                            <span className="nav-link-text ms-1">Email User List</span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item" style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/shoot-email" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <MdMarkEmailRead size={20} />
                            <span className="nav-link-text ms-1">Shoot Email</span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item" style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/all-contacts" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <FaRegUserCircle size={20} />
                            <span className="nav-link-text ms-1">All Contacts</span>
                          </div>
                        </NavLink>
                      </li>
                    </ul>
                  )}

                </li>
                <li className="nav-item">
                  <div className="nav-link cursor-pointer d-flex align-items-center justify-content-between" onClick={() => toggleMenu("pluc-lab")} style={{ cursor: "pointer" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <img
                        src="/image/14.png"
                        alt="User Earning"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <span className="nav-link-text ms-1">Pluc Creator Lab</span>
                    </div>
                    {/* <span className="nav-link-text ms-1">User Earning</span> */}
                    <i className={`fas fa-chevron-${openMenu === "pluc-lab" ? "up" : "down"} ms-auto`} style={{ padding: "10px" }} />
                  </div>

                  {/* Submenu */}
                  {openMenu === "pluc-lab" && (
                    <ul className="navbar-nav " style={{ paddingLeft: "20px" }}>
                      <li className="nav-item" onClick={handleSidebarClose} style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/pluc-lab-stroy" activeClassName="active">
                          {/* <span className="nav-link-text">User Earning List </span> */}
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/20.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Creator Lab Video
                            </span>
                          </div>
                        </NavLink>
                      </li>

                      <li className="nav-item" onClick={() => { if (openMenu !== "pluc-lab") handleSidebarClose() }} style={{ height: '52px' }}>
                        <NavLink className="nav-link mt-1" to="/pluc-user" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/plucUser.png"
                              alt="User Earning"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Creator Lab Users</span>
                          </div>
                        </NavLink>
                      </li>

                    </ul>
                  )}
                </li>


                <li className="nav-item">
                  <div
                    className="nav-link cursor-pointer d-flex align-items-center justify-content-between"
                    onClick={() => toggleMenu("assign-role")}
                    style={{ cursor: "pointer" }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <img
                        src="/image/20.png"
                        alt="Assign Role"
                        style={{ width: "20px", height: "20px" }}
                      />
                      <span className="nav-link-text ms-1">Assign Role</span>
                    </div>
                    <i
                      className={`fas fa-chevron-${openMenu === "assign-role" ? "up" : "down"} ms-auto`}
                      style={{ padding: "10px" }}
                    />
                  </div>

                  {/* ✅ FIX: Corrected the condition */}
                  {openMenu === "assign-role" && (
                    <ul className="navbar-nav" style={{ paddingLeft: "20px" }}>
                      <li
                        className="nav-item"
                        onClick={handleSidebarClose}
                        style={{ height: "52px" }}
                      >
                        <NavLink className="nav-link mt-1" to="/assign-role" activeClassName="active">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/20.png"
                              alt="Assign Role"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">Assign Role</span>
                          </div>
                        </NavLink>
                      </li>

                      <li className="nav-item" onClick={handleSidebarClose}>
                        <NavLink
                          className="nav-link"
                          activeClassName="active"
                          to="/getuserwithrole-details"
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <img
                              src="/image/assignrole.svg"
                              alt="GetUser With Role"
                              style={{ width: "20px", height: "20px" }}
                            />
                            <span className="nav-link-text ms-1">GetUser With Role</span>
                          </div>
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>


                <li className="nav-item">
                  <div
                    className="nav-link cursor-pointer d-flex align-items-center justify-content-between"
                    onClick={() => toggleMenu("whatsapp")}
                    style={{ cursor: "pointer" }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      {/* <img
                    src="/image/20.png"
                    alt="Whatsapp Message"
                    style={{ width: "20px", height: "20px" }}
                  /> */}
                      <FaWhatsapp size={20} />
                      <span className="nav-link-text ms-1">Whatsapp Message</span>
                    </div>
                    <i
                      className={`fas fa-chevron-${openMenu === "whatsapp" ? "up" : "down"} ms-auto`}
                      style={{ padding: "10px" }}
                    />
                  </div>
                  {openMenu === "whatsapp" && (
                    <ul className="navbar-nav" style={{ paddingLeft: "20px" }} >
                      <li
                        className="nav-item"
                        onClick={handleSidebarClose}
                      >
                        <NavLink className="nav-link mt-1" activeClassName="active" to="/view-template-message">
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <AiFillMessage size={20} />
                            <span className="nav-link-text ms-1">View Template Message</span>
                          </div>
                        </NavLink>
                      </li>
                      <li className="nav-item"
                        onClick={handleSidebarClose}
                      >
                        <NavLink
                          className="nav-link"
                          activeClassName="active"
                          to="/whatsapp-contact-list"
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                            <MdContactPage size={20} />
                            <span className="nav-link-text ms-1">Whatsapp Contact List</span>
                          </div>
                        </NavLink>
                      </li>


                    </ul>
                  )}
                </li>
                <li className="nav-item" onClick={handleSidebarClose}>
                  <NavLink className="nav-link" activeClassName="active" to="/services-list">
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <MdMiscellaneousServices size={20} />
                      <span className="nav-link-text ms-1">Services</span>
                    </div>
                  </NavLink>
                </li>
              </>

            )
            }
          </ul>
        </div>
      </aside>
    </>
  );
};
export default LeftbarAdmin;